<template>
	<div class="content_box">
		<div class="title">
			<span class="left_shu"></span>
			设备日志
		</div>
		<div class="page_top_box">
			<div class="top_input_box">
				<el-input placeholder="请输入设备名称" v-model="deviceName" clearable>
				</el-input>
			</div>
			<!-- <div class="top_input_box">
				<el-select v-model="scene" clearable placeholder="请选择产品场景">
					<el-option v-for="item in sceneList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div> -->
			<!-- <div class="top_input_box">
				<el-select v-model="deviceTypeId" clearable placeholder="请选择设备类型">
					<el-option v-for="item in searchTypeList" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</div> -->
			<!-- <div class="top_input_box">
				<el-date-picker v-model="time" type="date" placeholder="创建日期">
				</el-date-picker>
			</div> -->
			<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
		</div>
		<div class="table_box">
			<el-table :data="tableData" style="width: 100%;">
				<el-table-column prop="dataCode" label="数据码" align='center'>
				</el-table-column>
				<!-- <el-table-column prop="deviceId" label="设备ID" align='center'>
				</el-table-column> -->
				<el-table-column prop="deviceName" label="设备名称" align='center'>
				</el-table-column>
				<!-- <el-table-column prop="deviceTypeName" label="设备类型" align='center'>
				</el-table-column> -->
				<el-table-column prop="dataType" label="数据类型" align='center'>
				</el-table-column>
				<el-table-column prop="scene" label="产品场景" align='center'>
					<template slot-scope="scope">
						{{scope.row.scene==1?'线上展厅':scope.row.scene==2?'行为感知':scope.row.scene==3?'安防监控':scope.row.scene==4?'5G靶向车':'水质监测'}}
					</template>
				</el-table-column>
				<!-- <el-table-column prop="dataInfo" label="数据信息" align='center'>
				</el-table-column> -->
				<el-table-column prop="createTime" label="创建时间" align='center' width="200">
				</el-table-column>
				<el-table-column fixed="right" label="操作" align='center'>
					<template slot-scope="scope">
						<el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="table_paging">
				<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
					:total="currentTotal" background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>
		<div class="model" v-if="modelShow">
			<div class="mask" @click="hide"></div>
			<div class="model-dialog" style="width: 712px;">
				<div class="model-header">
					<span>日志详情</span>
					<i class="el-icon-close" @click="hide"></i>
				</div>
				<div class="model-body">
					<el-descriptions title="" direction="vertical" :column="4" border v-if="form.dissolvedOxygen">
						<el-descriptions-item label="设备Id">{{form.deviceId}}</el-descriptions-item>
						<el-descriptions-item label="溶解氧">{{form.dissolvedOxygen}}</el-descriptions-item>
						<el-descriptions-item label="溶解温度">{{form.dissolvedTemperature}}</el-descriptions-item>
						<el-descriptions-item label="电导率">{{form.elecConductivity}}</el-descriptions-item>
						<el-descriptions-item label="电气温度">{{form.elecTemperature}}</el-descriptions-item>
						<el-descriptions-item label="纬度">{{form.latitude}}</el-descriptions-item>
						<el-descriptions-item label="经度">{{form.longitude}}</el-descriptions-item>
						<el-descriptions-item label="酸碱度">{{form.ph}}</el-descriptions-item>
						<el-descriptions-item label="浊度">{{form.turbidity}}</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="" direction="vertical" :column="2" border v-if="form.alertId">
						<el-descriptions-item label="设备Id">{{form.alertId}}</el-descriptions-item>
						<el-descriptions-item label="设备编号">{{form.deviceSn}}</el-descriptions-item>
						<el-descriptions-item label="房间编号">{{form.roomSn}}</el-descriptions-item>
						<el-descriptions-item label="数据类型">跌倒</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="" direction="vertical" :column="4" border v-if="form.ccelertionX">
						<el-descriptions-item label="设备Id">{{form.deviceId}}</el-descriptions-item>
						<el-descriptions-item label="X方向加速度">{{form.ccelertionX}}</el-descriptions-item>
						<el-descriptions-item label="Y方向加速度">{{form.ccelertionY}}</el-descriptions-item>
						<el-descriptions-item label="Z方向加速度">{{form.ccelertionZ}}</el-descriptions-item>
						<el-descriptions-item label="大气压强">{{form.irPressure}}</el-descriptions-item>
						<el-descriptions-item label="降雨量">{{form.rinfllIntensity}}</el-descriptions-item>
						<el-descriptions-item label="倾倒状态">{{form.collpseSt}}</el-descriptions-item>
						<el-descriptions-item label="空气湿度">{{form.irHumi}}</el-descriptions-item>
						<el-descriptions-item label="空气温度">{{form.irTemp}}</el-descriptions-item>
						<el-descriptions-item label="臭氧">{{form.o3vl}}</el-descriptions-item>
						<el-descriptions-item label="一氧化碳">{{form.covl}}</el-descriptions-item>
						<el-descriptions-item label="二氧化硫">{{form.so2vl}}</el-descriptions-item>
						<el-descriptions-item label="二氧化氮">{{form.no2vl}}</el-descriptions-item>
						<el-descriptions-item label="光照强度">{{form.lightIntensity}}</el-descriptions-item>
						<el-descriptions-item label="风向">{{form.windDirection}}</el-descriptions-item>
						<el-descriptions-item label="风速">{{form.windSpeed}}</el-descriptions-item>
						<el-descriptions-item label="PM2.5">{{form.pm2p5}}</el-descriptions-item>
						<el-descriptions-item label="PM10">{{form.pm10}}</el-descriptions-item>
					</el-descriptions>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				deviceName: '', //搜索设备名称
				sceneList: [{
					value: 1,
					label: '线上展厅'
				}, {
					value: 2,
					label: '行为感知'
				}, {
					value: 3,
					label: '安防监控'
				}, {
					value: 4,
					label: '5G靶向车'
				}, {
					value: 5,
					label: '水质监测'
				}],
				scene: '', //搜索产品场景
				searchTypeList: [], //搜索设备类型列表
				deviceTypeId: '', //搜索设备类型
				// time: '',//搜索时间
				tableData: [], //数据
				currentPage: 1, //页数
				pageSize: 10, //每页数量
				currentTotal: 0, //总数
				modelShow: false,
				form: {}
			}
		},
		mounted() {
			this.getData()
			this.getSearchTypeList()
		},
		methods: {
			async getSearchTypeList() {
				let result = await this.request.post("/v1.0/deviceType/getPageData", {
					pageNum: 1,
					pageSize: 100,
				});
				this.searchTypeList = result.data.dataList
			},
			async getData() {
				let result = await this.request.post("/v1.0/deviceLog/getPageData", {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					deviceName: this.deviceName == '' ? null : this.deviceName,
					scene: 4,
					deviceTypeId: this.deviceTypeId
				});
				this.tableData = result.data.dataList
				this.currentTotal = result.data.totalCount - 0
			},
			// 搜索按钮
			search() {
				this.currentPage = 1
				this.pageSize = 10
				this.getData()
			},
			handleCurrentChange(val) {
				console.log(val)
				this.currentPage = val
				//点击下一页的时候 重新调用接口从后端取分页数据;{ current: this.currentPage } 为传给后端的字段
				this.getData()
			},
			handleClick(e) {
				this.request.post("/v1.0/deviceLog/getDetail", {
					id: e.id,
				}).then((result) => {
					if (result.code == 0) {
						this.form = result.data.dataInfoObj

					}
				})
				this.modelShow = true
			},
			hide() {
				this.modelShow = false
			},
		}
	}
</script>

<style>
</style>
